<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            md="9"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <p class="h5 mt-50 mr-75 ml-50">
              조회 타입
            </p>
            <b-form-radio-group
              v-model="query.isPrefixSum"
            >
              <b-form-radio :value="true">
                누적
              </b-form-radio>
              <b-form-radio :value="false">
                일별
              </b-form-radio>
            </b-form-radio-group>
            <p class="h5 mt-50 mr-75 ml-50">
              조회 기준
            </p>
            <b-form-radio-group
              v-model="query.countingGroup"
            >
              <b-form-radio :value="2">
                의원
              </b-form-radio>
              <b-form-radio :value="1">
                의사
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            md="9"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-datepicker
              v-model="query.searchStartDate"
              class="el-def"
              placeholder="게시시작일(Fr)"
              style="width: 250px"
            />
            <label class="ml-25 mr-50">~</label>
            <b-form-datepicker
              v-model="query.searchEndDate"
              class="el-def"
              placeholder="게시시작일(To)"
              style="width: 250px"
            />
            <label style="width: 140px">(*당일데이터 조회 불가)</label>
            <b-form-input
              v-model="query.liveInfoId"
              placeholder="ID검색"
              class="el-def"
            />
          </b-col>
          <b-col
            md="3"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-dark"
              class="btn-search ml-1"
              @click.prevent="excelDownload()"
            >
              <feather-icon
                icon="DownloadIcon"
                class="mr-50"
              />
              <span>엑셀 다운로드</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card>
      <div>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            해당 통계는 엑셀 다운로드만 제공됩니다.
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import { onMounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import dayjs from 'dayjs'
import { saveAs } from "file-saver"

export default {
  setup() {
    onMounted(() => {
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const query = ref({
      isPrefixSum: true,
      countingGroup: 2,
      clientId: null,
      liveInfoId: null,
      status: null,
      searchStartDate: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
      searchEndDate: dayjs().add(-1, 'day').format('YYYY-MM-DD'),
    })

    const medicalTrendData = ref([])

    const excelDownload = () => {
      const frDate = dayjs(query.value.searchStartDate)
      const toDate = dayjs(query.value.searchEndDate)

      if (Math.abs(frDate.diff(toDate, 'day')) > 90) {
        pushToast('warning', '조회 기간은 최대 90일을 넘을 수 없습니다.')
        return
      }

      axios.get(`/fa/statistics/medical/excel`, {
        params: {
          countingGroup: query.value.countingGroup,
          startDate: query.value.searchStartDate,
          endDate: query.value.searchEndDate,
          liveInfoId: query.value.liveInfoId,
          isPrefixSum: query.value.isPrefixSum,
        },
        responseType: 'blob',
      })
        .then(rs => {
          if (rs?.data?.size > 0) {
            const blob = new Blob([rs.data])

            const strViewType = query.value.isPrefixSum === true ? '누적' : '일별'
            const strCountingGroup = query.value.countingGroup === 1 ? '의사' : '의원'

            // saveAs(blob, `메디컬트렌드 통계(${query.value.isPrefixSum === true ? '누적' : '일별'}).xlsx`)
            saveAs(blob, `${query.value.liveInfoId ?? '전체'}__(${dayjs(query.value.searchStartDate).format('YYMMDD')}-${dayjs(query.value.searchEndDate).format('YYMMDD')})__메디컬트렌드 ${strViewType} 통계 (${strCountingGroup}).xlsx`)
          }
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: '데이터 조회 중 오류가 발생하였습니다.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    return {
      query,
      medicalTrendData,
      excelDownload,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
